var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navbar Icon",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66406 10.9371C2.66406 10.5091 3.01104 10.1621 3.43906 10.1621H7.81406C8.24208 10.1621 8.58906 10.5091 8.58906 10.9371C8.58906 11.3651 8.24208 11.7121 7.81406 11.7121H4.21406V16.5621C4.21406 16.9901 3.86708 17.3371 3.43906 17.3371C3.01104 17.3371 2.66406 16.9901 2.66406 16.5621V10.9371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41406 16.5621C1.41406 16.1341 1.76104 15.7871 2.18906 15.7871H17.8141C18.2421 15.7871 18.5891 16.1341 18.5891 16.5621C18.5891 16.9901 18.2421 17.3371 17.8141 17.3371H2.18906C1.76104 17.3371 1.41406 16.9901 1.41406 16.5621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03906 7.18711C7.03906 6.75909 7.38604 6.41211 7.81406 6.41211H12.1891C12.6171 6.41211 12.9641 6.75909 12.9641 7.18711C12.9641 7.61513 12.6171 7.96211 12.1891 7.96211H8.58906V16.5621C8.58906 16.9901 8.24208 17.3371 7.81406 17.3371C7.38604 17.3371 7.03906 16.9901 7.03906 16.5621V7.18711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4141 3.43711C11.4141 3.00909 11.761 2.66211 12.1891 2.66211H16.5641C16.9921 2.66211 17.3391 3.00909 17.3391 3.43711V16.5621C17.3391 16.9901 16.9921 17.3371 16.5641 17.3371H12.1891C11.761 17.3371 11.4141 16.9901 11.4141 16.5621V3.43711ZM12.9641 4.21211V15.7871H15.7891V4.21211H12.9641Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.6bff3b71a7deb9037d3b11ea79c1fa50.svg";
export { ForwardRef as ReactComponent };